import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("tvde_user");
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tvde_token");
    if (token) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("tvde_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("tvde_token");
        localStorage.removeItem("tvde_user");
        setUser(null);
      }).finally(() => setLoading(false));
    } else setLoading(false);
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("tvde_token", r.data.token);
    localStorage.setItem("tvde_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("tvde_token");
    localStorage.removeItem("tvde_user");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
